import { getQueryString } from "./utils"
let API = ""
let WAPAPI = ""
let API2 = ""
let CE = ""
let USERAPI = ""
let HZAPI = ""
let HZ_PC_API = ""
let MALLAPI = ""
let ULKAPI = ""
let MULKAPI = ""
let ORDERAPI = ""
let IMGAPI = ""
let ENV = ""
let HZ_MB_API = ""
let STYLE = ""
let COMPONENT_API = ""

if (
  process.env.REACT_APP_PROJECT_ENV === "production" &&
  process.env.NODE_ENV === "production"
) {
  API = "https://www.ibuychem.com/"
  CE = "https://www.ibuychem.com/"
  WAPAPI = "https://m.ibuychem.com/"
  API2 = "https://m.ibuychem.com/"
  USERAPI = "https://user.ibuychem.com/"
  HZAPI = "https://user.hzeyun.com/"
  MALLAPI = "https://cn.ibuychem.com/"
  ULKAPI = "https://ylcool.com/"
  MULKAPI = "https://m.ylcool.com/"
  ORDERAPI = "https://order.ibuychem.com/"
  IMGAPI = "https://img.ibuychem.com/"
  HZ_PC_API = "https://www.hzeyun.com/"
  HZ_MB_API = "https://m.hzeyun.com/"
  COMPONENT_API = "https://component.ibuychem.com/"
  STYLE = "https://style.ibuychem.com/"
  ENV = "production"
} else {
  API = "https://www-stg.ibuychem.com/"
  CE = "https://www-stg.ibuychem.com/"
  API2 = "https://m-stg.ibuychem.com/"
  WAPAPI = "https://m-stg.ibuychem.com/"
  USERAPI = "https://user-stg.ibuychem.com/"
  HZAPI = "https://user-stg.hzeyun.com/"
  MALLAPI = "https://cn-stg.ibuychem.com/"
  ULKAPI = "https://stg.ylcool.com/"
  MULKAPI = "https://m-stg.ylcool.com/"
  ORDERAPI = "https://order-stg.ibuychem.com/"
  IMGAPI = "https://imgdev.ibuychem.com/"
  HZ_PC_API = "https://www-stg.hzeyun.com/"
  HZ_MB_API = "https://m-stg.hzeyun.com/"
  COMPONENT_API = "https://component-stg.ibuychem.com/"
  STYLE = "https://style-stg.ibuychem.com/"
  ENV = "development"
}

export default {
  API,
  CE,
  WAPAPI,
  API2,
  USERAPI,
  HZAPI,
  HZ_PC_API,
  MALLAPI,
  ULKAPI,
  MULKAPI,
  ORDERAPI,
  IMGAPI,
  ENV,
  HZ_MB_API,
  STYLE,
  COMPONENT_API,
}

// 登录参数名单
export const queryList = [
  {
    url: "/auth/realname",
    list: [
      {
        returnUrl: (function () {
          const pageType = getQueryString("type")
          if (pageType) {
            return (
              window.location.origin +
              "/mobile/uc/build/auth/realname?type=" +
              pageType
            )
          }
          return window.location.origin + "/mobile/uc/build/auth/realname"
        })(),
      },
    ],
  },
  {
    url: "/u/product/edit?type=1&source=1",
    list: [
      {
        returnUrl:
          window.location.origin +
          "/mobile/uc/build/u/product/edit?type=1&source=1",
      },
    ],
  },
  {
    url: "/u/product/activity",
    list: [
      {
        returnUrl:
          window.location.origin + "/mobile/uc/build/u/product/activity",
      },
      { must: 1 },
    ],
  },
]
export const captchaAppId = "198741889"
